import { computed } from 'vue'

import type { ProgramsStoreValuesType } from '@/features/programs/stores/programs/programs.store'
import type { V2ProgramType } from '@/features/programs/types'

export function selectGetSelectedProgramId(state: ProgramsStoreValuesType) {
  return computed(() => state.selectedProgramId)
}
export function selectGetSelectedPeriodId(state: ProgramsStoreValuesType) {
  return computed(() => state.selectedPeriodId)
}

export function selectGetIsProgramDataLoading(state: ProgramsStoreValuesType) {
  return computed(() => state.isProgramDataLoading)
}

export function selectGetSelectedPeriod(
  state: ProgramsStoreValuesType,
  programs: V2ProgramType[] | undefined,
) {
  return computed(() => {
    const selectedProgramId = state.selectedProgramId
    const selectedPeriodId = state.selectedPeriodId

    if (!selectedProgramId || !selectedPeriodId || !programs) {
      return undefined
    }

    const selectedProgram = programs.find((program) => program.id === selectedProgramId)
    if (!selectedProgram) {
      return undefined
    }

    return selectedProgram.periods.find((period) => period.id === selectedPeriodId)
  })
}
